import { createFileRoute } from '@tanstack/react-router';
import { settingsQueryOptions } from '@/features/settings/api';
import { BudgetPage } from '@/features/settings/budget/BudgetPage';

export const Route = createFileRoute('/_auth/settings/budget')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(settingsQueryOptions()).catch(() => undefined),
  component: BudgetPage,
});
